import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import cacheAssetIfNeeded from "../../utils/cacheAssetIfNeeded";
import findElementByName from "../../utils/findElementByName";
import calculateVideoDuration from "../../utils/calculateVideoDuration";

const adjustElementDuration = (
  element: Record<string, any>,
  videoStartTime: number,
  videoDuration: number
): Record<string, any> => {
  const elementDurationFromVideo = element?.duration + (element?.time - videoStartTime);
  if (videoDuration < elementDurationFromVideo) {
    // We need to sustract the time that it will take the name to appear
    const newOverlayDuration = videoDuration - (element.time - videoStartTime);
    if (newOverlayDuration > 0) return { [`${element.id}.duration`]: newOverlayDuration };
  }

  return {};
};

const synopsysDefaultPortraitVideoTemplate = async ({
  preview,
  mediaElements,
  defaultVideoProperties,
  organization: organizationName,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const nameElement = findElementByName(elements, ELEMENT_NAMES.NAME);
  const titleElement = findElementByName(elements, ELEMENT_NAMES.TITLE);
  const companyNameElement = findElementByName(elements, ELEMENT_NAMES.COMPANYNAME);
  const lowerOverlayElement = findElementByName(elements, ELEMENT_NAMES.LOWER_TH_OVERLAY);
  const promptElement = findElementByName(elements, ELEMENT_NAMES.PROMPT);
  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);
  const introElement = findElementByName(elements, ELEMENT_NAMES.INTRO);
  const outroElement = findElementByName(elements, ELEMENT_NAMES.OUTRO);

  const nameElements = elements?.find((element: Record<string, any>) => (
    element.id === nameElement?.id
  ));
  const titleElements = elements?.find((element: Record<string, any>) => (
    element.id === titleElement?.id
  ));
  const companyNameElements = elements?.find((element: Record<string, any>) => (
    element.id === companyNameElement?.id
  ));
  const lowerOverlayElements = elements?.find((element: Record<string, any>) => (
    element.id === lowerOverlayElement?.id
  ));

  const INTRO_DURATION = introElement?.duration ?? 0;
  const STORY_TIME = storyVideoElement?.time ?? 0;
  const TRANSITION = (introElement?.duration - storyVideoElement?.time);

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    width: storyVideoElement?.width,
    height: storyVideoElement?.height,
    animations: storyVideoElement?.animations
  }, STORY_TIME);
  await deleteElement(preview, storyVideoElement?.id);
  const videoDuration = calculateVideoDuration(mediaElements);

  let mod: { [x: string]: string | number } = {
    [`${nameElement?.id}.text`]: story?.creator?.name || "",
    [`${titleElement?.id}.text`]: story?.creator?.title || "",
    [`${companyNameElement?.id}.text`]: organizationName.name || "",
    [`${promptElement?.id}.text`]: story?.question?.question || "",
    [`${outroElement?.id}.time`]: INTRO_DURATION + videoDuration - TRANSITION
  };

  const videoStartTime = storyVideoElement?.time || 0;
  mod = { ...mod, ...adjustElementDuration(lowerOverlayElements, videoStartTime, videoDuration) };
  mod = { ...mod, ...adjustElementDuration(nameElements, videoStartTime, videoDuration) };
  mod = { ...mod, ...adjustElementDuration(titleElements, videoStartTime, videoDuration) };
  mod = { ...mod, ...adjustElementDuration(companyNameElements, videoStartTime, videoDuration) };

  await preview.applyModifications(mod);
};

export default synopsysDefaultPortraitVideoTemplate;
